import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FilterGroupsService, FilterGroup } from '@services/filter-groups.service';
import { FilterGroupDialogComponent } from './filter-group-dialog/filter-group-dialog.component';
import { FilterGroupLogsDialogComponent } from './filter-group-logs-dialog/filter-group-logs-dialog.component';
import { ConfigService } from '@services/config.service';

@Component({
  selector: 'app-filter-groups',
  templateUrl: './filter-groups.component.html',
  styleUrls: ['./filter-groups.component.scss'],
  standalone: false
})
export class FilterGroupsComponent implements OnInit {

  displayedColumns: string[] = ['name', 'derivedFieldName', 'derivedFieldValue', 'retroactiveFromDate', 'isActive', 'conditionOperator', 'conditions', 'jobStatus', 'jobProgress', 'jobEtaHours', 'actions'];
  dataSource: FilterGroup[] = [];
  isLoading = false;

  constructor(
    private filterGroupsService: FilterGroupsService,
    private toastr: ToastrService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.loadFilterGroups();
  }

  loadFilterGroups(): void {
    this.isLoading = true;
    this.filterGroupsService.getFilterGroups().subscribe({
      next: (res: any) => {
        this.dataSource = res.body || [];
        this.isLoading = false;
      },
      error: () => {
        this.toastr.error('Failed to load filter groups');
        this.isLoading = false;
      }
    });
  }

  addFilterGroup(): void {
    const config = ConfigService.getDialogConfigWide();
    config.disableClose = true;
    config.data = {};
    const dialogRef = this.dialog.open(FilterGroupDialogComponent, config);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.toastr.success('Filter group created');
        this.loadFilterGroups();
      }
    });
  }

  editFilterGroup(filterGroup: FilterGroup): void {
    const config = ConfigService.getDialogConfigWide();
    config.disableClose = true;
    config.data = { filterGroup };
    const dialogRef = this.dialog.open(FilterGroupDialogComponent, config);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.toastr.success('Filter group updated');
        this.loadFilterGroups();
      }
    });
  }

  viewLogs(filterGroup: FilterGroup): void {
    this.filterGroupsService.getFilterGroup(filterGroup.id).subscribe({
      next: (res: any) => {
        const fg: FilterGroup = res.body || res;
        const config = ConfigService.getDialogConfigWide();
        config.data = { logs: fg.jobLog, name: fg.name, derivedFieldName: fg.derivedFieldName };
        this.dialog.open(FilterGroupLogsDialogComponent, config);
      },
      error: () => this.toastr.error('Failed to load logs')
    });
  }

  getConditionsSummary(filterGroup: FilterGroup): string {
    if (!filterGroup.conditions || filterGroup.conditions.length === 0) {
      return 'No conditions';
    }
    return filterGroup.conditions.map(c => c.fieldLabel).join(', ');
  }
}
